import dayjs from 'dayjs';
import 'dayjs/locale/id';
import React from 'react';
import { handleValueSelected } from '../../../utils/builder/common';
import DateRangePicker from '../../elements/DateRangePicker/DateRangePicker';
import MultipleSelect from '../../fields/MultipleSelect';
import Select from '../../fields/SelectBox/Select';
import IconUpDownArrow from '../../icons/IconUpDownArrow';
export const defaultDateRange = [
  dayjs().subtract(6, 'day').toDate(),
  dayjs().toDate(),
];

export const initialValues = {
  registrationDate: defaultDateRange,
  regional: '',
  provinceId: '',
  cityId: '',
  districtId: '',
  villageId: '',
  agenId: '',
  sbmId: '',
  samId: '',
  wave: ''
};

export const Fields = ({
  values = initialValues,
  handleChangeValues,
  handleGetAgents,
  // handleChangeValuesDate,
  dropdownData,
  regionalId,
  provinceId,
  // cityId,
  cities,
  // maxDate,
  // minDate,
  type,
  sbm,
  sam,
  handleSearchFilter,
  valueDate,
  setValueDate
}) => {

  const datePickerProps = {
    allowSingleDateInRange: true,
    dropdownPosition: 'bottom-start',
    valueFormat: 'DD MMM YYYY',
    locale: 'id',
    placeholder: 'Pilih tanggal',
    rightSection: <IconUpDownArrow />,
    type: 'range',
  };

  const fieldStatus = type === 'failed' ?
    [{
      label: 'Status',
      disabled: false,
      component: (
        <Select
          data={dropdownData.status}
          eventName="status"
          hideLabel
          name="status"
          onChangeSelect={(value) =>
            handleChangeValues({ name: 'status', value })
          }
          placeholder="Pilih Status"
          rightSection={<IconUpDownArrow />}
          valueForm={values.status}
        />
      ),
    }] : [];
  return [
    {
      label: 'Tanggal Registrasi',
      component: (
        <DateRangePicker
          inputProps={datePickerProps}
          maxDate={new Date()}
          onChange={(value) => {
            setValueDate(value);
            if (Object.values(value).every((item) => Boolean(item))) {
              handleChangeValues({
                name: 'registrationDate',
                value,
              });
            }
          }}
          value={valueDate}
        />
      ),
    },
    {
      label: 'Wave',
      component: (
        <Select
          data={dropdownData.waves}
          eventName="wave"
          hideLabel
          name="wave"
          onChangeSelect={(value) =>
            handleChangeValues({ name: 'wave', value })
          }
          placeholder="Pilih Wave"
          rightSection={<IconUpDownArrow />}
          valueForm={values.wave}
        />
      ),
    },
    ...fieldStatus,
    {
      label: 'Regional',
      disabled: regionalId !== '',
      component: (
        <MultipleSelect
          border={false}
          data={dropdownData.regional}
          disabled={regionalId}
          eventName="regional"
          hideLabel
          name="regional"
          onChange={(value) => {
            const isSelectedAll = value.findIndex((val) => val === '*');
            handleChangeValues({ name: 'regional', value: isSelectedAll > -1 || value.length === 0 ? '*' : value });
          }
          }
          overflow={'unset'}
          placeholder="Semua Regional"
          rightSection={<IconUpDownArrow />}
          searchable={true}
          value={handleValueSelected(values.regional, regionalId)}
        />
      ),
    },
    {
      label: 'SAM',
      disabled: sam?.id,
      component: (
        <MultipleSelect
          border={false}
          data={dropdownData.sam}
          disabled={sam?.id}
          eventName="sam"
          hideLabel
          name="sam"
          onChange={(value) => {
            const isSelectedAll = value.findIndex((val) => val === '*');
            handleChangeValues({ name: 'sam', value: isSelectedAll > -1 || value.length === 0 ? '*' : value });
          }
          }
          overflow={'unset'}
          placeholder="Semua SAM"
          rightSection={<IconUpDownArrow />}
          searchable={true}
          value={handleValueSelected(values.samId, sam?.id)}
        />
      ),
    },
    {
      label: 'SBM',
      disabled: sbm?.id,
      component: (
        <MultipleSelect
          data={dropdownData.sbm}
          debounce={true}
          disabled={sbm?.id}
          eventName="sbm"
          hideLabel
          name="sbm"
          onChange={(value) => {
            const isSelectedAll = value.findIndex((val) => val === '*');
            handleChangeValues({ name: 'sbm', value: isSelectedAll > -1 || value.length === 0 ? '*' : value });
          }
          }
          onSearchChange={handleSearchFilter}
          overflow={'unset'}
          placeholder="Semua SBM"
          rightSection={<IconUpDownArrow />}
          searchable={true}
          value={handleValueSelected(values.sbmId, sbm?.id)}
        />
      ),
    },
    {
      label: 'Provinsi',
      disabled: false,
      component: (
        <MultipleSelect
          border={false}
          data={dropdownData.provinces}
          eventName="provinces"
          hideLabel
          name="provinceId"
          onChange={(value) =>{
            const isSelectedAll = value.findIndex((val) => val === '*');
            handleChangeValues({ name: 'provinceId', value: isSelectedAll > -1 || value.length === 0 ? '*' : value });
          }
          }
          overflow={'unset'}
          placeholder="Semua Provinsi"
          rightSection={<IconUpDownArrow />}
          searchable={true}
          value={values.provinceId || provinceId}
        />
      ),
    },
    {
      label: 'Kota/Kab',
      disabled: JSON.stringify(cities)?.length === 40,
      component: (
        <MultipleSelect
          // data={(provinceId || values.provinceId) ? dropdownData.cities :
          // [{ value: JSON.stringify(cities), label: 'Semua Kota/Kab' }]}
          border={false}
          data={dropdownData.cities}
          debounce={true}
          eventName="cities"
          hideLabel
          name="cityId"
          onChange={(value) => {
            const isSelectedAll = value.findIndex((val) => val === '*');
            handleChangeValues({ name: 'cityId', value: isSelectedAll > -1 || value.length === 0 ? '*' : value });
          }
          }
          onSearchChange={handleSearchFilter}
          overflow={'unset'}
          placeholder="Semua Kota/Kab"
          rightSection={<IconUpDownArrow />}
          searchable={true}
          value={values.cityId}
        />
      ),
    },
    {
      label: 'Kecamatan',
      // disabled: JSON.stringify(cities)?.length === 2 || JSON.stringify(cities)?.length === 0 ,
      component: (
        <MultipleSelect
          border={false}
          // data={(values.cityId) ? dropdownData.districts :
          //  [{ value: '', label: 'Semua Kecamatan' }]}
          data={dropdownData.districts}
          debounce={true}
          eventName="districts"
          hideLabel
          name="districtId"
          onChange={(value) => {
            const isSelectedAll = value.findIndex((val) => val === '*');
            handleChangeValues({ name: 'districtId', value: isSelectedAll > -1 || value.length === 0 ? '*' : value });
          }
          }
          onSearchChange={handleSearchFilter}
          overflow={'unset'}
          placeholder="Semua Kecamatan"
          rightSection={<IconUpDownArrow />}
          searchable={true}
          value={values.districtId}
        />
      ),
    },
    {
      label: 'Kelurahan',
      // disabled: !values.districtId,
      component: (
        <MultipleSelect
          border={false}
          // data={(values.districtId) ? dropdownData.villages :
          //  [{ value: '', label: 'Semua Kelurahan' }]}
          data={dropdownData.villages}
          debounce={true}
          eventName="villages"
          hideLabel
          name="villageId"
          onChange={(value) => {
            const isSelectedAll = value.findIndex((val) => val === '');
            handleChangeValues({ name: 'villageId', value: isSelectedAll > -1 || value.length === 0 ? '' : value });
          }
          }
          onSearchChange={handleSearchFilter}
          overflow={'unset'}
          placeholder="Semua Kelurahan"
          rightSection={<IconUpDownArrow />}
          searchable={true}
          value={values.villageId}
        />
      ),
    },
    {
      label: 'ID Agen',
      component: (
        <Select
          data={dropdownData.agents}
          eventName="agent"
          hideLabel
          name="agent"
          onChangeSelect={(value) =>
            handleChangeValues({ name: 'agenId', value })
          }
          onSearchChange={handleGetAgents}
          placeholder="Semua Agen"
          rightSection={<IconUpDownArrow />}
          valueForm={values.agenId}
        />
      ),
    },
  ];
};
